import {ManagerDiscount} from './ManagerDiscount';
export default ManagerDiscount;